module.exports = __webpack_public_path__ + "static/img/code.6601f32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code.jpg
// module id = d46q
// module chunks = 10